import React from 'react';
import cl from './Spinner.module.css';

/**
 * Brand-спиннер StartKlass.
 *
 * Props:
 *   size:     'small' | 'medium' | 'large'  (48 / 72 / 96 px)
 *   text:     текст подписи (по умолчанию «Загружаем»)
 *   showText: false — без подписи
 *   center:   true  — центрирование внутри родителя (flex)
 *   fullPage: true  — занять видимую область (min-height: 280px)
 */
export default function Spinner({
    size = 'medium',
    text = 'Загружаем',
    showText = true,
    center = false,
    fullPage = false,
}) {
    const wrapperCls = [
        cl.wrapper,
        center && cl.center,
        fullPage && cl.fullPage,
    ].filter(Boolean).join(' ');

    return (
        <div className={wrapperCls}>
            <div className={`${cl.spinner} ${cl[size]}`}>
                <div className={cl.ringOuter}/>
                <div className={cl.ringInner}/>
                <div className={cl.dot}/>
            </div>
            {showText && (
                <div className={cl.label}>
                    {text}
                    <span className={cl.dots}>
                        <span/><span/><span/>
                    </span>
                </div>
            )}
        </div>
    );
}
